<div class="grid">
  <div class="col-10">
    <form [formGroup]="registerFormCompany" (ngSubmit)="searchForCuit()" id="container-form">
      <h2 class="mb-0">Crear cuenta</h2>
      <p>{{ selectedRol }}</p>
      <div class="grid mt-1">
        <div class="custom-input col-12 md:col-12 lg:col-12 flex flex-column">
          <label for="cuit">CUIT *</label>
          <p-inputMask
            mask="99-99999999-9"
            placeholder="99-99999999-9"
            formControlName="cuit"
            [ngClass]="{ 'ng-invalid ng-dirty': hasErrors('cuit', 'required') }"
          ></p-inputMask>
          <div
            class="text-danger p-error"
            *ngIf="hasErrors('cuit', 'required')"
          >
            Este campo es obligatorio
          </div>
        </div>
      </div>
      <div
        class="info-message p-3 mb-3 legend"
      >
        <p class="text-justify text-sm m-0">
          <i class="pi pi-info-circle mr-1 text-sm"></i>
          Ingrese el CUIT para buscar automáticamente los datos de la empresa.
          Si no encontramos información, podrá completar los datos manualmente
          en el siguiente paso.
        </p>
      </div>

      <p-button
        class="nextButton"
        label="Buscar"
        [disabled]="registerFormCompany.get('cuit')?.invalid"
        type="submit"
      ></p-button>
      <span class="backLink"><a (click)="previusStep()">Volver</a></span>
    </form>
  </div>
</div>
